var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"column"},[_c('rev-card',{attrs:{"reviewable":_vm.reviewable}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }